<template>
  <v-layout>
    <v-dialog v-model="dialog" scrollable max-width="640px">
      <v-card>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline bluetext">
          Status bearbeiten
        </v-card-text>
        <v-card-text style="overflow: auto; max-height: 400px">

              <v-layout class="pa-4" row wrap>
                <v-flex xs12 class="text-left">
                  Hier können Sie den Namen anpassen und die Farbe konfigurieren
                </v-flex>
                <v-flex xs3 class="pa-1">
                  <v-text-field v-model="cellData.title" label="Feldname" @change="updateName()"></v-text-field>
                </v-flex>
                <v-flex xs3 class="pa-1">
                  <v-text-field v-model="config.color" label="Farbe" @change="updateColor()"></v-text-field>
                  <Chrome v-model="config.color" @input="onChangeColor"/>
                </v-flex>
              </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-btn class="text-none" color="black" outline flat @click="dialog = false">abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="text-none" color="examenis" outline flat @click="closeDialog">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
// import Vue from 'vue'
import { Chrome } from 'vue-color'

export default {
  name: 'DialogConfigStatus',
  components: {Chrome},
  props: ['onCloseEventName'],
  methods: {
    closeDialog: function () {
      this.dialog = false
      var that = this
      that.cellData.config = JSON.stringify(this.config)
      this.$emit('onSave', {
        item: that.cellData,
        extraFields: that.tableItems,
        categorySelectWord: that.categorySelectWord
      })
    },
    updateName () {
      this.widgetId = this.widgetName.toLowerCase().trim()
      this.widgetId = this.widgetId.replace(/[^a-zA-Z0-9]/g, '')
    },
    updateColor () {
      this.widgetId = this.widgetName.toLowerCase().trim()
      this.widgetId = this.widgetId.replace(/[^a-zA-Z0-9]/g, '')
    },
    open: function (item) {
      console.log('item', item)
      this.cellData = item
      if (item.config && (typeof item.config === 'string')) {
        item.config = item.config.replaceAll('\'', '"')
        try {
          let c = JSON.parse(item.config)
          if (c) {
            this.config = c
          }
        } catch (eee) {

        }
      }
      if (!this.config.color) {
        this.config.color = '#aaaaaa'
      }
      this.categorySelectWord = item.categorySelectWord
      this.dialog = true
    },
    deleteItem (item) {
      let index = this.tableItems.indexOf(item)
      this.tableItems.splice(index, 1)
    },
    onChangeColor (attrs, name) {
      console.log('onChangeColor', attrs, name)
      this.config.color = attrs.hex
    }
  },
  data () {
    return {
      config: {
        color: '#66FF44'
      },
      cellData: {},
      categorySelectWord: '',
      active: null,
      widgetTyp: 'Currency',
      widgetName: 'Neues Feld',
      tableItems: [],
      widgetId: '',
      widgetValueLabel: '€',
      widgetList: [],
      dialog: false,
      name: '',
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Typ',
          align: 'left',
          sortable: false,
          value: 'typ'
        },
        {text: 'Aktion', value: 'action'}
      ]
    }
  },
  mounted () {
    //
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/DialogConfigStatus.vue